import { getGraphQLClient } from 'config/libs/globals'
import { getCurrentCountry, getCurrentLanguage } from 'config/utils/CommonFunction'
import {
  getDownloadExportResponseType,
  downloadType,
  getAssetExportResponseType,
} from 'types/export.Type'
import { GET_ASSET_EXPORT_URL, GET_DOWNLOAD_EXPORT, GET_EXPORT_URL } from './queries/exportQueries'
import { API_YEAR } from 'config/constants'

const getExportUrlQuery = async (pageId: number): Promise<string> => {
  try {
    const currentCountry = await getCurrentCountry()
    const currentLanguage = await getCurrentLanguage()
    const { data } = await getGraphQLClient().query({
      query: GET_EXPORT_URL(pageId, currentLanguage.languageCode, currentCountry.code, API_YEAR),
    })
    if (!data) {
      throw new Error('data is undefined')
    }
    return data?.getExportUrl
  } catch (error) {
    console.error('Error getExportUrlQuery:', error)
    throw new Error('Failed to getExportUrlQuery')
  }
}
const getDownloadContent = async ({
  homeAndGarden,
  professional,
}: {
  homeAndGarden?: boolean
  professional?: boolean
}): Promise<getDownloadExportResponseType> => {
  try {
    const currentCountry = await getCurrentCountry()
    const currentLanguage = await getCurrentLanguage()

    const categories: [keyof getDownloadExportResponseType] = ['AK_DCA_COMMON']
    if (homeAndGarden) {
      categories.push('AK_DCA_HOME_AND_GARDEN')
    }
    if (professional) {
      categories.push('AK_DCA_PROFESSIONAL')
    }
    const { data } = await getGraphQLClient().query({
      query: GET_DOWNLOAD_EXPORT(
        currentLanguage.languageCode,
        currentCountry.code,
        API_YEAR,
        categories,
      ),
    })
    if (!data) {
      throw new Error('data is undefined')
    }
    return data?.getDownloadExport
  } catch (error) {
    console.error('Error getDownloadContentAll:', error)
    throw new Error('Failed to getDownloadContentAll')
  }
}

const getAssetExportQuery = async (
  downloadType: downloadType,
): Promise<getAssetExportResponseType> => {
  try {
    const currentCountry = await getCurrentCountry()
    const currentLanguage = await getCurrentLanguage()

    const { data } = await getGraphQLClient().query({
      query: GET_ASSET_EXPORT_URL(
        downloadType,
        currentLanguage.languageCode,
        currentCountry.code,
        API_YEAR,
      ),
    })
    if (!data) {
      throw new Error('data is undefined')
    }
    return data?.getAssetExport
  } catch (error) {
    console.error('Error getAssetExportQuery:', error)
    throw new Error('Failed to getAssetExportQuery')
  }
}

export { getExportUrlQuery, getDownloadContent, getAssetExportQuery }
